/** Auto-generated by the constants_user_experience.py script */
enum UserExperience {
  ClinicalInsightsPreventCalc = 'ClinicalInsightsPreventCalc',
  FaxLetter = 'FaxLetter',
  GlobalPatientSearchPopup = 'GlobalPatientSearchPopup',
  InboxAnnotateAndProviderLetter = 'InboxAnnotateAndProviderLetter',
  InboxPreviewPatientLetter = 'InboxPreviewPatientLetter',
  NoteAssistFeedbackPopover = 'NoteAssistFeedbackPopover',
  PLR4Everyone = 'PLR4Everyone',
  Payments2ElectricBoogalooPopup = 'Payments2ElectricBoogalooPopup',
  PostDateLetter = 'PostDateLetter',
  ReportPreviewBanner = 'ReportPreviewBanner',
  SendTelehealthInstructions = 'SendTelehealthInstructions',
  TelehealthInRemindersNotice = 'TelehealthInRemindersNotice',
}

export default UserExperience;
